<template>
  <div>
    <h1 class="auth-layout__title">{{ $t('login.create_new_password') }}</h1>
    <h2 v-if="passwordExpired">{{ $t('login.password_has_expired') }}</h2>
    <a-form
        :form="form"
        id="formPasswordRecovery"
        class="auth-layout__form"
        @submit="handleSubmit"
    >
      <a-form-item :label="$t('login.current_password')">
        <a-input-password
            size="large"
            type="password"
            @change="keyupInput"
            :placeholder="$t('login.enter_password')"
            v-decorator="[
                'current_password',
                {rules: [
                    {required: true, message: $t('messages.passwordRequired')},
                ]},
            ]"
        >
        </a-input-password>
        <div v-if="isRequestError && errors.current_password" class="custom-error">{{ errors.current_password }}</div>
      </a-form-item>

        <hr />
      <a-form-item :label="$t('login.new_password')">
        <a-input-password
            size="large"
            type="password"
            @change="keyupInput"
            :placeholder="$t('login.enter_password')"
            v-decorator="[
                'password',
                {rules: [
                    {required: true, message: $t('messages.passwordRequired')},
                    {validator: validateToNextPassword},
                    {pattern: new RegExp('^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{5,15}$'), message: $t('messages.passwordRegExp')}]},
            ]"
        >
        </a-input-password>
      </a-form-item>
      <a-form-item :label="$t('login.confirm_new_password')">
        <a-input-password
            size="large"
            type="password"
            @change="keyupInput"
            :placeholder="$t('login.confirm_password_placeholder')"
            v-decorator="[
                'password_confirmation',
                {rules: [
                    {required: true, message: $t('messages.passwordConfirm')},
                    {validator: compareToFirstPassword}]},
            ]"
        >
        </a-input-password>
        <div v-if="isRequestError && (errors.length === 0 || errors.password || errors.password_confirmation )" class="custom-error">{{ errors.password ? errors.password : $t('messages.passwordIsNotValid') }}</div>
      </a-form-item>
      <div class="auth-layout__action">
         <a-button
             type="primary"
             html-type="submit"
             :loading="changeButton"
             :disabled="changeButton || hasErrors(form.getFieldsError()) || isRequestError">
          {{ $t('login.save_password') }}
        </a-button>
      </div>
    </a-form>
  </div>
</template>

<script>
import { hasErrors } from '@/utils/helpers/checkFormErrors';
import {mapMutations} from 'vuex';
import { passwordRegExp, passwordRequired, passwordConfirm, passwordIsNotValid } from "@/utils/messages";

export default {
  name: 'ChangePassword',
  data() {
    return {
      hasErrors,
      passwordRegExp,
      passwordRequired,
      passwordConfirm,
      passwordIsNotValid,
      confirmDirty: false,
      changeButton: false,
      isRequestError: false,
      isMobile: false,
      errors: {}
    }
  },
  beforeCreate() {
    this.form = this.$form.createForm(this, { name: 'recoveryPassword' });
  },
  mounted() {
    this.SET_BG_IMAGE_PATH("/auth_images/White6.png");
    this.$route.query.mobile == "1" ? this.isMobile = true : null;
  },
  computed: {
    passwordExpired() {
     return this.$store.getters['getPasswordExpiredState'];
    },
  },
  methods: {
    ...mapMutations(['SET_BG_IMAGE_PATH']),
    compareToFirstPassword(rule, value, callback) {
      const form = this.form;
      if (value && value !== form.getFieldValue('password')) {
        callback(this.$t('login.two_passwords_error'));
      } else {
        callback();
      }
    },
    validateToNextPassword(rule, value, callback) {
      const form = this.form;
      if (value && this.confirmDirty) {
        form.validateFields(['password_confirmation'], { force: true });
      }
      callback();
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          let newPassword = {
            current_password: values.current_password,
            password: values.password,
            password_confirmation: values.password_confirmation
          }

          this.$store.dispatch('ChangePassword', newPassword)
            .then(()=> {
                this.changeButton = false;
                this.returnToDashboard();
            })
            .catch((e) => {
              this.errors = {};
              this.isRequestError = true
              if (e) {
                if (e.response.status === 422) {
                  try {
                    Object.entries(e.response.data.error.errors).forEach(([key, value]) => {
                      if(values[key]) {
                        this.errors[key] = value.join("\n")
                      }
                    });
                  } catch (error) {}
                  setTimeout(() => {
                      this.isRequestError = false;
                      this.changeButton = false;
                  },10000);
                }
              }
            })
            .finally(() => {
              this.changeButton = false
            });
        }
      });
    },
    keyupInput() {
      this.changeButton = false
      this.isRequestError = false
    },
    returnToDashboard() {
      if (parseInt(this.$store.getters['getRole']) === 1) {
          this.$router.push({ path: '/dashboard/organization-list' })
      } else {
          this.$router.push({ path: '/dashboard/profile' })
      }
    }
  },
};
</script>

<style lang="less" scoped></style>
